import { render, staticRenderFns } from "./PaymentList.vue?vue&type=template&id=8b0228a8&scoped=true&lang=pug&"
import script from "./PaymentList.vue?vue&type=script&lang=ts&"
export * from "./PaymentList.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentList.vue?vue&type=style&index=0&id=8b0228a8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0228a8",
  null
  
)

export default component.exports